import { DateTimeEditor } from '@dataGrid/components/cellEditors';

import { withStyles } from '@material-ui/core';

const styles = () => ({
  inputRoot: {
    height: 35,
    borderRadius:3
  },
  dateTimeContainer: {
    margin: 0
  }
});

export default withStyles(styles)(DateTimeEditor);
